module.exports = __webpack_public_path__ + "static/img/bg4.f262e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/bg4.png
// module id = YVvH
// module chunks = 70